var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAmexIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.709 9.04 0 15.212h3.243l.402-.984h.918l.402.984h3.57v-.75l.318.75h1.846l.318-.767v.767h7.423l.902-.958.846.958L24 15.22l-2.717-3.076L24 9.041h-3.753l-.879.94-.819-.94h-8.075l-.693 1.592-.71-1.592H5.835v.725l-.36-.725zm.627.877h1.58l1.797 4.184V9.917h1.732l1.387 3 1.28-3h1.722v4.428h-1.048l-.009-3.47-1.528 3.47H9.31l-1.537-3.47v3.47H5.618l-.41-.993H3l-.408.992H1.437zm14.72 0h-4.263v4.425h4.197l1.352-1.466 1.304 1.466h1.363l-1.981-2.2 1.98-2.225h-1.303l-1.346 1.45zm-13.951.75-.728 1.767h1.455zm10.74.975v-.809h2.66l1.161 1.292-1.212 1.3h-2.608v-.882h2.325v-.901z",
  clipRule: "evenodd"
})));
export default SvgAmexIcon;